<script>
import { defineComponent, h, computed } from 'vue';
import { Bar } from 'vue-chartjs';
import store from '../../store/index';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default defineComponent({
  name: 'BarChart',
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    const chartDataStore = computed({
      get: () => store.state.statistics.horizontalBarChartData,
    });

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: 'y',
      scales: {
        y: {
          ticks: {
            callback: function (value) {
              const valueLegend = this.getLabelForValue(value);
              const valueLegendRep = valueLegend.replaceAll('', '');
              return valueLegendRep.length > 25
                ? valueLegendRep.substring(0, 24) + '...'
                : valueLegendRep;
            },
          },
        },
             x: {
                 ticks: {
                   callback: function(value) {
                    return '€' + Number(parseFloat(value)).toLocaleString('nl-NL');
                     }
                 }
             }
      },
      plugins: {
        tooltip: {
            callbacks: {
                label: function(context) {
                    var label = context.dataset.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (context.parsed.x !== null) {
                      label += '€' + Number(parseFloat(context.parsed.x)).toLocaleString('nl-NL');
                    }
                    return label;
                }
            }
        }
    },        
    };

    return () =>
      h(Bar, {
        chartData: chartDataStore.value,
        chartOptions,
        chartId: props.chartId,
        width: props.width,
        height: props.height,
        cssClasses: props.cssClasses,
      });
  },
});
</script>
